import { useLanguage } from '../i18n';

export function AboutPage(): JSX.Element {
  const { t } = useLanguage();

  return (
    <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
      <h1 className="text-3xl font-semibold">{t('about.title')}</h1>
      <div className="mt-6 space-y-5 text-sm leading-7 text-[color:var(--muted)]">
        <p>{t('about.p1')}</p>
        <p>{t('about.p2')}</p>
        <p>{t('about.p3')}</p>
      </div>
      <section className="mt-10 grid gap-3 sm:grid-cols-3">
        {[
          ['about.card1Title', 'about.card1Body'],
          ['about.card2Title', 'about.card2Body'],
          ['about.card3Title', 'about.card3Body']
        ].map(([title, body]) => (
          <div key={title} className="rounded-lg border border-[color:var(--line)] bg-[color:var(--panel)] p-4">
            <h2 className="text-sm font-semibold">{t(title)}</h2>
            <p className="mt-2 text-sm text-[color:var(--muted)]">{t(body)}</p>
          </div>
        ))}
      </section>
    </main>
  );
}
